import { render, staticRenderFns } from "./MaTestForm.vue?vue&type=template&id=1fe01d42"
import script from "./MaTestForm.vue?vue&type=script&lang=js"
export * from "./MaTestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports